import { render, staticRenderFns } from "./vehicle.estimate.detail.vue?vue&type=template&id=72c2341d&"
import script from "./vehicle.estimate.detail.vue?vue&type=script&lang=js&"
export * from "./vehicle.estimate.detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports